import { bscTestnet } from "wagmi/chains";
import { useContractRead, useNetwork } from "wagmi";

import { NFT_CONTRACT } from "../config";
import abi from "../contracts/hermes.abi.json";

export const useNFTMinted = () => {
  const { chain } = useNetwork();
  const contract = NFT_CONTRACT[chain?.id] || NFT_CONTRACT[bscTestnet.chainId];

  const { data, isLoading } = useContractRead({
    abi,
    args: [],
    functionName: "count",
    address: contract,
  });

  return {
    isLoading,
    data: parseInt(data) || 0,
  };
};
